"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHListInputHandler = exports.KHListInputs = void 0;
const KHInputHandler_1 = require("../Input/KHInputHandler");
class KHListInputs {
}
exports.KHListInputs = KHListInputs;
KHListInputs.Up = "up";
KHListInputs.Left = "left";
KHListInputs.Right = "right";
KHListInputs.Down = "down";
KHListInputs.Back = "back";
/**
 * Helper for setting up input handlers for menus.
 */
class KHListInputHandler extends KHInputHandler_1.KHInputHandler {
    constructor(scene, left, right, up, down, back, inputSet) {
        super(scene, {
            [KHListInputs.Left]: left,
            [KHListInputs.Right]: right,
            [KHListInputs.Up]: up,
            [KHListInputs.Down]: down,
            [KHListInputs.Back]: back,
        }, inputSet);
    }
}
exports.KHListInputHandler = KHListInputHandler;
